import { getCurrentInstance } from "vue";

export function useComponentId() {
  return getCurrentInstance()?.uid;
}
